import axiosInstance from '@/api'
import fileDownload from 'js-file-download'

export default async function downloadFile(url: string, nameFile: string, bodyData: unknown = undefined): Promise<void> {
  const response = await axiosInstance.post(url, bodyData, { responseType: 'blob' })
  fileDownload(response.data, nameFile)
}
